import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  launcher: {
    position: 'fixed',
    right: theme.spacing(2),
    bottom: theme.spacing(3),
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    textTransform: 'none',
    padding: '6px 12px',
    '&:hover': { backgroundColor: theme.palette.background.default },
  },
  launcherText: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' },
  scopeCaption: {
    fontSize: 10,
    fontWeight: 400,
    lineHeight: 1.3,
    maxWidth: 210,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  count: {
    marginLeft: 10,
    padding: '1px 6px',
    borderRadius: 4,
    backgroundColor: theme.palette.action.selected,
    fontVariantNumeric: 'tabular-nums',
  },
  desktopFrame: { position: 'fixed', right: 16, bottom: 24, zIndex: theme.zIndex.drawer + 2 },
  mobileFrame: { display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  paper: {
    width: 440,
    maxWidth: 'calc(100vw - 24px)',
    height: 570,
    maxHeight: 'calc(100vh - 100px)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    outline: 0,
    border: `1px solid ${theme.palette.divider}`,
    fontSize: 12,
    '& button': { textTransform: 'none' },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      height: '85vh',
      maxHeight: 'calc(100dvh - 24px)',
      borderRadius: '8px 8px 0 0',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 44,
    padding: '4px 10px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
  },
  title: { fontSize: 14, fontWeight: 600, flex: 1, margin: '0 6px' },
  listPane: { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 },
  filter: { margin: '8px 12px', flexShrink: 0 },
  status: {
    padding: '5px 12px',
    fontSize: 11,
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  scroll: { overflowY: 'auto', flex: 1, minHeight: 0, overscrollBehavior: 'contain' },
  table: { width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' },
  th: {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    textAlign: 'left',
    fontSize: 10,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    padding: '6px 10px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    zIndex: 1,
  },
  cell: {
    padding: '8px 10px',
    verticalAlign: 'top',
    borderBottom: `1px solid ${theme.palette.divider}`,
    overflowWrap: 'anywhere',
    lineHeight: 1.4,
  },
  orderButton: {
    border: 0,
    background: 'none',
    padding: 0,
    color: theme.palette.primary.main,
    font: 'inherit',
    fontWeight: 600,
    cursor: 'pointer',
    textAlign: 'left',
    '&:focus-visible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 3 },
  },
  critical: { color: theme.palette.error.main, fontWeight: 600 },
  secondary: { fontSize: 10, color: theme.palette.text.secondary, display: 'block' },
  empty: { padding: '24px 16px', textAlign: 'center', color: theme.palette.text.secondary },
  section: { padding: '10px 12px', borderBottom: `1px solid ${theme.palette.divider}` },
  sectionTitle: { fontSize: 12, fontWeight: 600, margin: '0 0 8px' },
  fields: {
    display: 'grid',
    gridTemplateColumns: '112px minmax(0, 1fr)',
    gap: '4px 10px',
    margin: 0,
    lineHeight: 1.45,
    '& dt': { color: theme.palette.text.secondary },
    '& dd': { margin: 0, overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' },
  },
  message: { margin: '6px 0 10px', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' },
  historyEntry: { padding: '10px 0', borderBottom: `1px solid ${theme.palette.divider}` },
  skeleton: { padding: '10px 12px' },
  retry: { color: theme.palette.error.main, padding: '8px 12px' },
  more: { display: 'flex', justifyContent: 'center', padding: 8 },
}));
